var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('section',{staticClass:"section-hero section-shaped my-0"},[_c('Particles',{staticClass:"section-header",attrs:{"id":"tsparticles","particlesInit":_vm.particlesInit,"particlesLoaded":_vm.particlesLoaded,"options":{
            "background": {
                "color": {
                    "value": _vm.colors.background
                },
                /*"image": "url(/img/theme/img-bg.jpg)",*/
                "position": "50% 50%",
                "repeat": "no-repeat",
                "size": "cover"
            },
            "fullScreen": {
                "zIndex": -1,
                "enable": false
            },
            "interactivity": {
                "events": {
                    "onHover": {
                        "enable": true,
                        "mode": _vm.colors.mode
                    }
                },
                "modes": {
                    "bubble": {
                        "distance": 400,
                        "duration": 2,
                        "opacity": 1,
                        /*"size": 100,*/
                        "divs": {
                            "distance": 200,
                            "duration": 0.4,
                            "mix": false,
                            "selectors": []
                        }
                    },
                    "grab": {
                        "distance": 400
                    },
                    "attract": {
                        "distance": 400,
                        "speed": 1
                    },
                    "repulse": {
                        "distance": 400,
                        "duration": 2,
                        "factor": 1,
                        "speed": 1
                    }
                }
            },
            "particles": {
                "color": {
                    "value": _vm.colors.bubble
                },
                "collisions": {
                    "bounce": {
                        "horizontal": {
                            "random": {
                                "enable": true,
                                "minimumValue": 0.5
                            },
                            "value": 1
                        },
                        "vertical": {
                            "random": {
                                "enable": true,
                                "minimumValue": 0.5
                            },
                            "value": 1
                        }
                    },
                    "enable": false,
                    "mode": "bounce",
                },
                
                "move": {
                    "enable": true,
                    "outModes": {
                        "bottom": "out",
                        "left": "out",
                        "right": "out",
                        "top": "out"
                    },
                    "speed": 0.5
                },
                "number": {
                    "density": {
                        "enable": true
                    },
                    "value": 50
                },
                "opacity": {
                    "animation": {
                        "speed": 0.2,
                        "minimumValue": 0.1
                    }
                },
                "size": {
                    "random": {
                        "enable": true,
                        "minimumValue": 50
                    },
                    "value": 80,
                    "animation": {
                        "speed": 20,
                        "minimumValue": 50
                    }
                }
            }
        }}}),_c('div',{staticClass:"section-header shape-container d-flex align-items-center"},[_c('div',{staticClass:"col px-0"},[_c('div',{staticClass:"row justify-content-center align-items-center"},[_c('div',{style:(`{z-index: 999; position:relative; height: 100%;}`)},[_c('img',{attrs:{"src":"img/brand/splash-new.png","width":"600px"}})])])])])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }